export default "__VITE_ASSET__CsUay2sM__"